/**
 * Post Engagement API functions (likes, bookmarks)
 * Authenticated requests require passing the axios instance from useAuthenticatedAxios
 */

/**
 * Check if current user has liked/bookmarked a post (authenticated)
 * @param {object} axiosInstance - Authenticated axios instance
 * @param {string} postId - Post ID
 */
export const checkEngagement = async (axiosInstance, postId) => {
    const response = await axiosInstance.get(
        `/api/engagements/check/${postId}`
    );
    return response.data;
};

/**
 * Like a post (authenticated)
 * @param {object} axiosInstance - Authenticated axios instance
 * @param {string} postId - Post ID
 */
export const likePost = async (axiosInstance, postId) => {
    const response = await axiosInstance.post('/api/engagements/reaction', {
        postId,
        reaction: 'like',
    });
    return response.data;
};

/**
 * Dislike a post (authenticated)
 * @param {object} axiosInstance - Authenticated axios instance
 * @param {string} postId - Post ID
 */
export const dislikePost = async (axiosInstance, postId) => {
    const response = await axiosInstance.post('/api/engagements/reaction', {
        postId,
        reaction: 'dislike',
    });
    return response.data;
};

/**
 * Bookmark a post (authenticated)
 * @param {object} axiosInstance - Authenticated axios instance
 * @param {string} postId - Post ID
 */
export const bookmarkPost = async (axiosInstance, postId) => {
    const response = await axiosInstance.post('/api/engagements/bookmark', {
        postId,
    });
    return response.data;
};

/**
 * Remove bookmark from a post (authenticated)
 * @param {object} axiosInstance - Authenticated axios instance
 * @param {string} postId - Post ID
 */
export const removeBookmark = async (axiosInstance, postId) => {
    const response = await axiosInstance.delete(
        `/api/engagements/bookmark/${postId}`
    );
    return response.data;
};

/**
 * Get user's bookmarked posts (authenticated)
 * @param {object} axiosInstance - Authenticated axios instance
 */
export const getBookmarkedPosts = async (axiosInstance) => {
    const response = await axiosInstance.get('/api/engagements/bookmarks');
    return response.data;
};
